var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-wrap",style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }